import { createContext } from 'react';

export const IDCardContext = createContext({
  IDCards: [],
  IDCard: {},
  competitions: [],
  competition: {},
  fields: [],
  users: [],
  user: {},
  signature: {
    background_image: null,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  userRank: {},
});
